import {peakAlert, peakConfirm} from "../../../PeakDialog.js";
import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountListingIndexFileFields implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountListingIndexFileFieldsContainer";
    }


    render() {
        let self=this;
        // console.log("listing index file fields");
        this.zidx.loadFunctions.push(function () {
            $(".zidxPageActive #listing_index_file_field_name", self.zidx.peakidxShadowRoot).off("change.k04").on("change.k04", function(this:HTMLSelectElement){
                let value=this.options[this.selectedIndex].value;
                let fileId=$(this).attr("data-file-id");
                if(value!=""){
                    let link="/account/data-feeds/listing-index/file/fields/edit?listing_index_file_id="+fileId+"&listing_index_file_field_name="+encodeURIComponent(value);
                    window.location.href=link;
                }
            });
            $('#autogenerateFields', self.zidx.peakidxShadowRoot).off("click.k04").on("click.k04", async function (this, e: JQuery.ClickEvent) {
                e.preventDefault();
                let r = await peakConfirm("Are you sure to generate elements automatically?");
                if (r) {
                    self.zidx.loadPushStateURL($(this).attr("href")!, false)
                }
            });
            $('#autogenerateDeleteAll', self.zidx.peakidxShadowRoot).off("click.k04").on("click.k04", async function (this, e: JQuery.ClickEvent) {
                e.preventDefault();
                let r = await peakConfirm("Are you sure to delete all elements?");
                if (r) {
                    self.zidx.ajaxRequest({
                        id: "ajaxDeleteAllFields",
                        method: "post",
                        ignoreOldRequests: false,
                        callback: function (resp: string) {
                            let js = JSON.parse(resp);
                            if (js.success) {
                                self.zidx.loadPushStateURL(js.redirectURL, false);
                            } else {
                                peakAlert("Failed to delete the fields. Error:\n\n" + js.errorMessage);
                            }
                        },
                        errorCallback: function () {
                            peakAlert("Failed to delete the fields. Unknown error");
                        },
                        url: $(this).attr("href")!
                    });
                }
            });
        })
    }
}